import { render, staticRenderFns } from "./ProductionBrief.vue?vue&type=template&id=1caec5ae&scoped=true&"
import script from "./ProductionBrief.vue?vue&type=script&lang=js&"
export * from "./ProductionBrief.vue?vue&type=script&lang=js&"
import style0 from "./ProductionBrief.vue?vue&type=style&index=0&id=1caec5ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caec5ae",
  null
  
)

export default component.exports